import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaBell, FaCommentAlt, FaHeart, FaShare, FaSearch, FaChevronDown } from "react-icons/fa";
import pipaanlogo from "../assets/pipaanlogo.png";
import groupimg from "../assets/groupimg.png";
import userimg from "../assets/user.png";
import profileimg from "../assets/profile.png";
import share from "../assets/share.png";
import newsfeed from "../assets/images/icons/newsfeed.png";
import friendsfollowers from "../assets/images/icons/friendsandfollowers.png";
import groupsandfamily from "../assets/images/icons/groupandfamily.png";
import chats from "../assets/images/icons/chats.png";
import profile from "../assets/images/icons/profile.png";
import Account from "../assets/images/icons/account-setting.png";
import help from "../assets/images/icons/helpandsupport.png";
import logout from "../assets/images/icons/logout.png";
import notification from "../assets/images/icons/notification.png";
import gallery from "../assets/images/icons/gallery.png";
import video from "../assets/images/icons/video.png";
import taguser from "../assets/images/icons/tag-user.png";
import send from "../assets/images/icons/send.png";
import global from "../assets/images/icons/global.png";
import hamburger from "../assets/images/icons/hamburger.png";
import hamburgerclose from "../assets/images/icons/hamburgerclose.png";
import closecircle from "../assets/images/icons/close-circle.png";
import FeedPost from "./feedpost/FeedPost";
import postData from "./feedpost/postdata";
import { Menu, X, Bell, User } from "lucide-react"; // Icons
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { FaTimes } from "react-icons/fa";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper/modules";

import { useNavigate } from "react-router-dom";

export default function HomePageNew() {
  // ✅ Define state properly
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [profiles, setProfiles] = useState([
    { id: 1, name: "John Doe", avatar: "https://via.placeholder.com/50", link: "/profile/1" },
    { id: 2, name: "Jane Smith", avatar: "https://via.placeholder.com/50", link: "/profile/2" },
    { id: 3, name: "Tech Group", avatar: "https://via.placeholder.com/50", link: "/group/tech" }
  ]);

  const [postText, setPostText] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [images, setImages] = useState([]);
  const navigate = useNavigate(); // Navigation hook

  useEffect(() => {
    if (searchQuery.length >= 3) {
      const filteredResults = profiles.filter(profile =>
        profile.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setSearchResults(filteredResults);
    } else {
      setSearchResults([]);
    }
  }, [searchQuery, profiles]);

  // const token =   sessionStorage.setItem("accessToken", accessToken);
  console.log("Stored Token in homepage:", sessionStorage.getItem("accessToken"));
  useEffect(() => {
    console.log("Checking stored token:", localStorage.getItem("accessToken"));
  }, []);
  
  const handleLogout = () => {
    // ✅ Remove auth token and user data from sessionStorage
    sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("user");
    console.log("logout")
    // ✅ (Optional) Remove from localStorage if you stored it there
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");

    console.log("User logged out successfully!");

    // ✅ Redirect to login page
    navigate("/login");
  };



  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  useEffect(() => {
    const storedUser = sessionStorage.getItem("user");
    const storedToken = sessionStorage.getItem("accessToken:::::");

    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    if (storedToken) {
      setToken(storedToken);
    }

    console.log("Retrieved User:", storedUser);
    console.log("Retrieved Token:", storedToken);
  }, []);
  // ✅ Handle File Selection (Images/Videos)
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };

  // ✅ Handle Post Submission
  const handlePostSubmit = () => {
    if (!postText.trim() && !selectedFile) {
      alert("Please enter text or upload a file.");
      return;
    }
    console.log("Post Submitted:", { text: postText, file: selectedFile });
    setPostText("");
    setSelectedFile(null);
    setIsPopupOpen(false);
  };

  // ✅ Separate function for toggling state
  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const [isPopupOpen, setIsPopupOpen] = useState(false); // 🔹 Popup state

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };


  // Handle Image Upload
  const handleImageUpload = (event) => {
    const files = Array.from(event.target.files);
    const newImages = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setImages((prevImages) => [...prevImages, ...newImages]);
  };

  // Remove Selected Image
  const removeImage = (index) => {
    setImages(images.filter((_, i) => i !== index));
  };
  return (

    <div className="dashboard w-full min-h-screen  flex">
      {/* Sidebar */}
      <aside className="w-80 sidebar-dashboard bg-[#F4F4F4] p-6 shadow-md hidden lg:block">
        <div className="float-sticky">
          <div className="logo flex items-center justify-center space-x-2 ">
            <img src={pipaanlogo} alt="Pipaan Logo" className="w-50" />
          </div>
          <nav className="space-y-4">
            <a href="#" className="active aside-menu rounded-xl">
              <img src={newsfeed} alt="" className="" /><span>New Feeds</span>
            </a>
            <a href="friendsfollowers" className="aside-menu hover:bg-gray-200 rounded-xl">
              <img src={friendsfollowers} alt="" className="" /><span>Friends & Followers</span>
            </a>
            <a href="#" className="aside-menu hover:bg-gray-200 rounded-xl">
              <img src={groupsandfamily} alt="" className="" /><span>Groups & Family</span>
            </a>
            <a href="#" className="aside-menu hover:bg-gray-200 rounded-xl">
              <img src={chats} alt="" className="" /><span>Chats</span>
            </a>
            <a href="#" className="aside-menu hover:bg-gray-200 rounded-xl">
              <img src={profile} alt="" className="" /><span>Profile</span>
            </a>
            <a href="#" className="aside-menu hover:bg-gray-200 rounded-xl">
              <img src={Account} alt="" className="" /><span>Account Settings</span>
            </a>
            <a href="#" className="aside-menu hover:bg-gray-200 rounded-xl">
              <img src={help} alt="" className="" /><span>Help & Support</span>
            </a>
            <a href="#" className="aside-menu hover:bg-red-200 rounded-xl text-red-600" onClick={handleLogout}
            >
              <img src={logout} alt="" className="" /><span>Logout</span>
            </a>
          </nav>
          <p className="copy-rights-app text-xs text-center text-[#095228]">&copy; 2025 Pipaan. All Rights Reserved</p>
        </div>
      </aside>


      <main className="flex-1 p-6">
        {/* Header */}
        <>
          {/* Header */}
          {/* Header */}
          <header className="flex items-center justify-between pb-8 lg:hidden">
            {/* Logo */}
            <div className="flex items-center space-x-3">
              <img src={pipaanlogo} alt="Pipaan Logo" className="w-30 h-30" />
            </div>

            {/* Icons: Profile & Notification */}
            <div className="flex items-center space-x-4">
              <div className="relative top-2">
                <img src={notification} alt="Notification" className="ml-4 cursor-pointer" />
              </div>
              <div className="profile-dashboard rounded-full overflow-hidden">
                <img src={profileimg} alt="Profile" className="w-full h-full object-cover" />
              </div>

              {/* Animated Hamburger Menu */}
              <button
                className={`lg:hidden p-2 rounded-md transition-all duration-300 ${isOpen ? "relative z-50" : "relative top-auto right-auto"
                  }`}
                onClick={() => setIsOpen(!isOpen)}
              >
                <motion.div
                  animate={{ rotate: isOpen ? 180 : 0 }} // Rotation effect
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                  className="w-6 h-6"
                >
                  <img
                    src={isOpen ? hamburgerclose : hamburger}
                    alt="Menu Toggle"
                    className="w-6 h-6 object-cover transition-all duration-300"
                  />
                </motion.div>
              </button>
            </div>
          </header>

          {/* Sidebar Navigation */}
          <aside
            className={`hamburg-popup fixed top-0 left-0 w-64 backdrop-blur m-5 p-6 h-full shadow-lg transition-transform ${isOpen ? "translate-x-0" : "-translate-x-full"
              } lg:hidden`}
          >
            <div className="pop border-[#C5C5C5]">
              {/* Navigation Links */}
              <nav className="space-y-4 my-8">
                <div className="space-x-2 mobile-hamburg">
                  <div className="search-fixed-menu">
                    <div className="text-center py-8">
                      <div className="profile-dashboard rounded-full overflow-hidden">
                        <img src={profileimg} alt="Profile" className="w-full h-full object-cover" />
                      </div>
                      <p className="font-semibold">Proveen Krishnamoorthy</p>
                      {/* <p>{user ? user.first_name : "N/A"}</p> */}
                      <p className="text-sm text-gray-500">@proveen_sky</p>
                    </div>
                  </div>
                </div>
                <a href="#" className="aside-menu aside-menu-sm hover:bg-gray-200 rounded-xl">
                  <img src={profile} alt="Profile Icon" />
                  <span>Profile</span>
                </a>
                <a href="#" className="aside-menu aside-menu-sm hover:bg-gray-200 rounded-xl">
                  <img src={Account} alt="Account Icon" />
                  <span>Account Settings</span>
                </a>
                <a href="#" className="aside-menu aside-menu-sm hover:bg-gray-200 rounded-xl">
                  <img src={help} alt="Help Icon" />
                  <span>Help & Support</span>
                </a>
                <a href="#" className="aside-menu aside-menu-sm hover:bg-red-200 rounded-xl text-red-600">
                  <img src={logout} alt="Logout Icon" />
                  <span>Logout</span>
                </a>
              </nav>
            </div>
          </aside>

        </>
        <div className="flex justify-between items-center mb-6 w-full">
          {/* Search Input with Icon */}
          <div className="flex relative w-full ">
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search for people, communities or groups"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input focus:outline-none focus:ring-2 focus:ring-gray-300"
            />
            {searchQuery.length >= 3 && (
              <ul className="search-results">
                {searchResults.map((result) => (
                  <li key={result.id}>
                    <Link to={result.link} className="search-result-item">
                      <img src={result.avatar} alt={result.name} className="avatar" />
                      <span>{result.name}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            )}
            <div className="relative top-2 hidden lg:block">{/* Notification Bell */}
              <img src={notification} alt="" className=" ml-4 cursor-pointer" />
            </div>
          </div>

          {/* Profile Section */}
          <div className="flex items-center space-x-2 hidden lg:block">
            <div className="search-fixed-menu flex justify-end">
              <div className="text-right pr-2">
                <p>{user ? user.first_name : "N/A"}</p>
                <p> {user ? user.email : "N/A"}</p>
                {/* <p className="text-sm text-gray-500">@proveen_sky</p> */}
              </div>
              <div className="profile-dashboard rounded-full overflow-hidden">
                <img src={profileimg} alt="Profile" className="w-full h-full object-cover" />
              </div>
            </div>
          </div>
        </div>
        {/* Main Content */}
        <main className="flex ">

          {/* Feeds */}
          <div className="flex-1 lg:pr-5 space-y-6">
            <div className=" mobile-nav md:hidden lg:hidden">
              <a href="#" className="active aside-menu rounded-xl">
                <img src={newsfeed} alt="" className="" /><span>New Feeds</span>
              </a>
              <a href="friendsfollowers" className="aside-menu hover:bg-gray-200 rounded-xl">
                <img src={friendsfollowers} alt="" className="" />
              </a>
              <a href="#" className="aside-menu hover:bg-gray-200 rounded-xl">
                <img src={groupsandfamily} alt="" className="" />
              </a>
              <a href="#" className="aside-menu hover:bg-gray-200 rounded-xl">
                <img src={chats} alt="" className="" />
              </a>
            </div>
            <div>
              {/* Create Post */}
              <div className="share-content relative">
                <div className="relative">
                  {/* Profile Image Inside Textarea */}
                  <img
                    src={profileimg}
                    alt="Profile"
                    className="prf absolute left-5 top-5 lg:w-10 lg:h-10 rounded-full"
                  />
                  <textarea
                    placeholder="Share something..."
                    value={postText}
                    // onChange={(e) => setPostText(e.target.value)}
                    className="share-input-field focus:outline-none focus:ring-2 focus:ring-gray-300 resize-none"
                    onClick={openPopup} // 🔹 Open popup when clicked

                  ></textarea>

                </div>
                <div className="flex justify-between items-center mt-2">
                  {/* Left Section (Image, Video, Tag Buttons) */}

                  <div className="flex">
                    <label className="flex items-center px-4 py-2 cursor-pointer">
                      <img src={gallery} alt="Gallery" className="pr-2" />
                      <input type="file" accept="image/*" className="hidden" multiple onChange={handleImageUpload} />
                      Image
                    </label>
                    <label className="flex items-center px-4 py-2 cursor-pointer">
                      <img src={video} alt="Video" className="pr-2" />
                      <input type="file" accept="video/*" className="hidden" onChange={handleFileChange} />
                      Video
                    </label>
                    <button className="flex items-center px-4 py-2 rounded-lg">
                      <img src={taguser} alt="Tag" className="pr-2" /> Tag
                    </button>
                  </div>

                  {/* Right Section (Dropdown & Post Button) */}
                  <div className="flex items-center">
                    {/* Public Dropdown */}
                    <div>
                      <button
                        onClick={toggleDropdown}
                        className="share-public flex items-center px-4 py-2"
                      >
                        <img src={global} alt="Globe" className="pr-2" />
                        Public
                        <FaChevronDown className="ml-2 text-xs text-gray-400" />
                      </button>

                      {/* ✅ Show dropdown only if isOpen is true */}
                      {isOpen && (
                        <div className="absolute top-12 left-0 bg-white shadow-md rounded-md w-40 p-2">
                          <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 1</button>
                          <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 2</button>
                          <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 3</button>
                        </div>
                      )}
                    </div>

                    {/* Post Button */}
                    <button className="post-cta flex px-4 py-2 rounded-lg bg-blue-500 text-white" onClick={handlePostSubmit}>
                      <img src={send} alt="Send" className="pr-2" /> Post
                    </button>
                  </div>
                </div>
              </div>

              {/* 🔹 Popup Modal (Shown when isPopupOpen is true) */}
              {isPopupOpen && (
                <div className="popup-share fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-60 w-full backdrop-blur-md">
                  <div className="border-popup bg-white rounded-lg  relative">
                    <div className="flex justify-between">
                      <div className="logo flex items-center justify-center space-x-2 ">
                        <img src={pipaanlogo} alt="Pipaan Logo" className="w-50" />
                      </div>
                      {/* Close Button */}
                      <button className="close-pop-x relative  text-gray-500" onClick={closePopup}>
                        <img src={closecircle} alt="Pipaan Logo" className="w-10 h-10" />
                      </button>
                    </div>

                    {/* Modal Content */}
                    <div className="share-content relative w-full">
                      <div className="relative">
                        {/* Profile Image Inside Textarea */}
                        <img
                          src={profileimg}
                          alt="Profile"
                          className="prf absolute left-5 top-5 lg:w-10 lg:h-10 rounded-full"
                        />
                        <textarea
                          placeholder="What's on your mind?"
                          onChange={(e) => setPostText(e.target.value)}
                          className="share-input-field focus:outline-none focus:ring-2 focus:ring-gray-300 resize-none" // 🔹 Open popup when clicked
                        ></textarea>
                        {/* 🔹 File Preview */}
                        {selectedFile && (
                          <div className="mt-4">
                            {selectedFile.type.startsWith("image") ? (
                              <img src={URL.createObjectURL(selectedFile)} alt="Preview" className="w-full h-auto rounded-lg" />
                            ) : (
                              <video controls className="w-full h-auto rounded-lg">
                                <source src={URL.createObjectURL(selectedFile)} type={selectedFile.type} />
                                Your browser does not support the video tag.
                              </video>
                            )}
                          </div>
                        )}
                      </div>
                      <div className="flex justify-between items-center mt-2">
                        {/* Left Section (Image, Video, Tag Buttons) */}
                        <div className="flex">
                          <label className="flex items-center px-4 py-2 cursor-pointer">
                            <img src={gallery} alt="Gallery" className="pr-2" />
                            <input type="file" accept="image/*" className="hidden" onChange={handleFileChange} />
                            Image
                          </label>
                          <label className="flex items-center px-4 py-2 cursor-pointer">
                            <img src={video} alt="Video" className="pr-2" />
                            <input type="file" accept="video/*" className="hidden" onChange={handleFileChange} />
                            Video
                          </label>
                          <button className="flex items-center px-4 py-2 rounded-lg">
                            <img src={taguser} alt="Tag" className="pr-2" /> Tag
                          </button>
                        </div>

                        {/* Right Section (Dropdown & Post Button) */}
                        <div className="flex items-center">
                          {/* Public Dropdown */}
                          <div>
                            <button
                              onClick={toggleDropdown}
                              className="share-public flex items-center px-4 py-2"
                            >
                              <img src={global} alt="Globe" className="pr-2" />
                              Public
                              <FaChevronDown className="ml-2 text-xs text-gray-400" />
                            </button>

                            {/* ✅ Show dropdown only if isOpen is true */}
                            {isOpen && (
                              <div className="absolute top-12 left-0 bg-white shadow-md rounded-md w-40 p-2">
                                <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 1</button>
                                <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 2</button>
                                <button className="block w-full text-left px-3 py-2 hover:bg-gray-100">Option 3</button>
                              </div>
                            )}
                          </div>

                          {/* Post Button */}
                          <button className="post-cta flex px-4 py-2 rounded-lg bg-blue-500 text-white" onClick={handlePostSubmit}>
                            <img src={send} alt="Send" className="pr-2" /> Post
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div class="feed-tabs w-full mx-auto text-center lg:text-left">
              <div class=" flex items-center  gap-x-6 justify-between">
                <h2 class="text-3xl font-semibold tracking-tight text-balance text-black sm:text-4xl">Feeds</h2>
                <div className="filter bg-[#EBF8ED] lg:p-3">
                  <a href="#" class="lg:p-3 active focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white">Interests</a>
                  <a href="#" class="lg:p-3  text-black">Groups</a>
                  <a href="#" class="lg:p-3  text-black">Followers</a>
                </div>
              </div>
            </div>
            {[1, 2, 3].map((post) => (
              <div key={post}>
                <div className="w-full ">
                  {postData.map((post, index) => (
                    <FeedPost key={index} post={post} />
                  ))}
                </div>
              </div>
            ))}
            <div className="slider-md-swiper">
              <aside className=" bg-white p-3  md:hidden">
                <div className="">
                  {/* Followers Section */}
                  <h3 className="followers-title mb-4">Based on Your Followers</h3>
                  <Swiper
                    spaceBetween={10}
                    slidesPerView={3}
                    // navigation
                    // pagination={{ clickable: true }}
                    modules={[Navigation, Pagination]}
                  >
                    {[1, 2, 3, 4].map((user) => (
                      <SwiperSlide key={user}>
                        <div className="followers ">
                          <img src={userimg} alt="User" className="w-15 h-15 rounded-full" />
                          <div className="">
                            <p className="titlesemibold">Marketing Group</p>
                            <p className="members">764 members</p>
                          </div>
                          <button className="follow-cta">Follow</button>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>

                  <hr className="my-4" />

                  {/* Groups Section */}
                  <h3 className="followers-title mt-6 mb-4">Based on Your Groups</h3>
                  <Swiper
                    spaceBetween={10}
                    slidesPerView={3}
                    // navigation
                    // pagination={{ clickable: true }}
                    modules={[Navigation, Pagination]}
                  >
                    {[1, 2, 3].map((group) => (
                      <SwiperSlide key={group}>
                        <div className="followers">
                          <img src={userimg} alt="User" className="w-15 h-15 rounded-full" />
                          <div className="">
                            <p className="titlesemibold">Marketing Group</p>
                            <p className="members">764 members</p>
                          </div>
                          <button className="follow-cta">Follow</button>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </aside>
            </div>
          </div>
          {/* Right Sidebar */}

          <aside className="w-80 bg-white p-3  hidden lg:block follow-aside">
            <div className="right-sidebar-fixed">
              <h3 className="followers-title mb-4">Based on Your Followers</h3>
              {[1, 2, 3, 4].map((user) => (
                <div key={user} className=" followers">
                  <img src={userimg} alt="User" className="w-15 h-15 rounded-full" />
                  <div className="pl-4">
                    <p className="titlesemibold">Marketing Group</p>
                    <p className="members">764 members</p>
                  </div>
                  <button className="follow-cta">Follow</button>
                </div>
              ))}
              <hr></hr>
              <h3 className="font-semibold mt-6 mb-4">Based on Your Groups</h3>
              {[1, 2, 3].map((group) => (
                <div key={group} className="followers ">
                  <img src={userimg} alt="User" className="w-15 h-15 rounded-full" />
                  <div className="pl-4">
                    <p className="titlesemibold">Marketing Group</p>
                    <p className="members">764 members</p>
                  </div>
                  <button className="follow-cta">Follow</button>
                </div>
              ))}

            </div>
          </aside>

        </main>
      </main>
    </div >
  );
}
